import { ENV } from '@/common/config'
import { changeLoginStatus, changeUserInfoStatus, isLogin } from '@/models/userInfo';
import { debounce } from 'lodash';
import { getUserInfo } from '@/service/login';
import { isOversea } from '@/models/common';

let isRunning = false
let root: any = null
let ssoPlus: any = null
const aihouseLoginURL = {
  dev: 'https://hws-aihouse.3weijia.com/graph',
  test: 'https://hws-aihouse.3weijia.com/graph',
  hws: 'https://hws-aihouse.3weijia.com/graph',
  pre: 'https://pre-www.aihouse.com/graph',
  prod: 'https://www.aihouse.com/graph'
}
/**
* @description 接口是否需要登录
*/
export const isNeedLogin = async (url: string, code: number) => {
  const noLoginUrls: string[] = ['sd-biz/api/user/v1/get']
  const needLoginUrls: string[] = [
    'materialLibrary/favorite/v1/page',
    'materialLibrary/recent/v1/page',
    'materialLibrary/download/v1/page',
    'designMaterial/v1/mine',
    'upload/material/tasks',
    '/sd-material/api/materialLibrary/favorite/v1/remove',
    '/sd-material/api/materialLibrary/favorite/v1/add',
    'api/designMaterial/v1/getBasicInfo',
    'api/materialLibrary/likes/v1/add',
    '/sd-material/api/oss/v1/sign'
  ]
  const threedApi = [
    'workbench-basic-web/categoryManagement/updateSortCode',
    'Web3D.axd'
  ]
  const noLoginCode = [100001011, 100001030, 120430623, 120020623, 100001030, 120430605]

  const noLoginMatch = noLoginUrls.some((substring: string) => url.includes(substring))
  const needLoginMatch = needLoginUrls.some((substring: string) => url.includes(substring))
  const threedApineedLoginMatch = threedApi.some((substring: string) => url.includes(substring))
  if (threedApineedLoginMatch) {
    const res = await getUserInfo()
    if (!res) {
      initLoginDebounced()
      return true
    }
    return false
  }
  if (noLoginMatch) {
    return false
  }
  if (needLoginMatch && noLoginCode.includes(code)) {
    initLoginDebounced()
    return true
  }
  return false
}

/**
  * @description 初始化登录
  */
export const initLogin = async (successCallback?: () => void, cancelCallback?: () => void) => {
  const res = await getUserInfo()
  if (res) {
    if (sessionStorage.getItem('use-session-storage-state-gobal-active')?.includes('design-circle') && !isLogin) {
      location.reload()
    }
    changeLoginStatus(true)
    changeUserInfoStatus(res)
  } else {
    // 海外登录
    if (isOversea) {
      // 不是iframe嵌入模式，通过postMessage通知父级页面跳转登录
      if (window.self !== window.top && window.location.href.includes('website')) {
        ((window as any)?.parent || (window as any)?.opener)?.postMessage({
          action: 'login',
          source: 'assets-plaza'
        }, '*')
      } else {
        const loginURL = aihouseLoginURL[ENV];
        window.location.href = `${loginURL}?callbackurl=${window.location.href}`
      }

    } else {
      // 确保每次都能弹出登录窗口
      if (!(window as any).ssoPlus) return
      
      // 如果已经存在登录弹窗，先隐藏
      if (root) {
        root.hide()
      }
      
      ssoPlus = (window as any).ssoPlus({
        appId: 'materialSquare',
        env: ENV
      });
      
      root = await ssoPlus.getLoginPop({
        container: '#material-root',
        async loginSuccess(data: any) {
          console.log(data, '注册成功回调');
          refreshParent()
          refreshHeader()
          isRunning = true
          const res = await getUserInfo()
          if (res) {
            changeLoginStatus(true)
            changeUserInfoStatus(res)
          }
          root.hide();
          if (successCallback) {
            successCallback?.()
          } else {
            window.location.reload()
          }
          isRunning = false
        },
        closeCallback() {
          if (!isRunning) {
            cancelCallback?.()
            console.log('关闭回调')
          }
        }
      })
      root.show()
    }
  }

}
/**
* @description 登录状态改变时，刷新父级页面
*/
export const refreshParent = () => {
  ((window as any)?.parent || (window as any)?.opener)?.postMessage('refreshContent', '*')
}
/**
* @description 登录状态改变时，刷新头部
*/
export const refreshHeader = () => {
  window.postMessage('refreshContent', '*')
}
const initLoginDebounced = debounce(initLogin, 500);
